import * as CryptoJS from 'crypto-js';
import { CONFIG } from 'src/config-global';

const key = CONFIG.encryptLocalStorageKey;

export const encrypt = (value: string): string => CryptoJS.AES.encrypt(value, key).toString();
export const decrypt = (value: string | null): string => {
  try {
    return value ? CryptoJS.AES.decrypt(value, key).toString(CryptoJS.enc.Utf8) : '';
  } catch (e) {
    return value ?? '';
  }
};
